import api, { API_URL } from '../api';

export const notificationService = {

  async getCategories() {
    try {
      const response = await api.get(`${API_URL}/notifications/categories`);
      if (Array.isArray(response.data)) {
        console.log('Retrieved categories:', response.data);
        return response.data;
      } else {
        console.error('Unexpected response format:', response.data);
        return [];
      }
    } catch (error) {
      console.error('Error fetching categories:', error.response?.data || error.message);
      return [];
    }
  },

  async updateSubscription(category, isSubscribed) {
    try {
      const response = await api.post(`${API_URL}/notifications/subscribe/`, {
        category,
        is_subscribed: isSubscribed
      });
      
      this.updateLocalSubscription(category, isSubscribed);
      
      return response.data;
    } catch (error) {
      console.error('Error updating subscription:', error);
      throw error;
    }
  },

  async bulkUpdateSubscriptions(categories) {
    try {
      const response = await api.post(`${API_URL}/notifications/subscribe/bulk/`, {
        categories
      });
      
      // Update local storage for all categories
      const subscriptions = this.getLocalSubscriptions();
      categories.forEach(cat => {
        subscriptions[cat.category] = cat.is_subscribed;
      });
      localStorage.setItem('notificationSubscriptions', JSON.stringify(subscriptions));
      
      return response.data;
    } catch (error) {
      console.error('Error bulk updating subscriptions:', error);
      throw error;
    }
  },
  getLocalSubscriptions() {
    try {
      const stored = localStorage.getItem('notificationSubscriptions');
      return stored ? JSON.parse(stored) : {};
    } catch (error) {
      console.error('Error reading local subscriptions:', error);
      return {};
    }
  },

  updateLocalSubscription(category, isSubscribed) {
    try {
      const subscriptions = this.getLocalSubscriptions();
      subscriptions[category] = isSubscribed;
      localStorage.setItem('notificationSubscriptions', JSON.stringify(subscriptions));
    } catch (error) {
      console.error('Error updating local subscription:', error);
    }
  },

  isSubscribed(category) {
    const subscriptions = this.getLocalSubscriptions();
    return subscriptions[category] !== false; // Default to true if not set
  },

  async getUserSubscriptions() {
    try {
      const response = await api.get(`${API_URL}/notifications/subscriptions/`);
      
      // Store in localStorage for offline access
      if (response.data) {
        const subscriptions = {};
        if (Array.isArray(response.data)) {
          response.data.forEach(sub => {
            subscriptions[sub.category] = sub.is_subscribed;
          });
        } else if (response.data.results) {
          response.data.results.forEach(sub => {
            subscriptions[sub.category] = sub.is_subscribed;
          });
        }
        localStorage.setItem('notificationSubscriptions', JSON.stringify(subscriptions));
      }
      
      return response.data;
    } catch (error) {
      console.error('Error fetching user subscriptions:', error);
      // Return local storage data as fallback
      return this.getLocalSubscriptions();
    }
  }
};

export default notificationService;